import * as React from 'react';
import { IModelEntity } from '../data/types';

interface IListSearch {
  search: (term: string) => void;
  searchTerm: string;
  list: IModelEntity[];
  clear: () => void;
}

/**
 * @description
 * @returns
 */
export const useListSearch = (originalList: IModelEntity[]): IListSearch => {
  const [searchTerm, search] = React.useState<string>('');

  const clear = (): void => search('');

  const list = React.useMemo((): IModelEntity[] => {
    if (searchTerm.length > 0) {
      return originalList.filter((model: IModelEntity): boolean =>
        model.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    } else {
      return originalList;
    }
  }, [JSON.stringify(originalList), searchTerm]);

  return {
    search,
    searchTerm,
    list,
    clear,
  };
};
